import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';

import { Chip } from '../../../material-ui/Chip';
import { downloadDocument, showPdf } from '../../../../actions/documents';
import { useStyles } from '../useStyles';

export const Documents = memo(({ documents }) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const handleClick = useCallback((id, isDownloaded, name) => {
        if (isDownloaded) {
            dispatch(showPdf(`${id}`));
        } else {
            dispatch(downloadDocument(id, name));
        }
    }, []);

    return (
        <>
            {documents.map(({ id, isDownloaded, name, type }) => (
                <Chip
                    key={id}
                    className={classnames(classes.documentButton, isDownloaded ? null : classes.warningButton)}
                    label={type ? type : name}
                    variant="outlined"
                    onClick={() => handleClick(id, isDownloaded, name)}
                />
            ))}
        </>
    );
});

Documents.displayName = 'Documents';
